import * as rg4js from 'raygun4js';
import { ErrorHandler, Injector, Injectable } from '@angular/core';
import { AppConfig } from './app-config';

const VERSION_NUMBER = '1.0.0.0';
rg4js('apiKey', 'zcZ0C205Img7bbxvgRnxzQ');
rg4js('setVersion', VERSION_NUMBER);
rg4js('options', { excludedHostnames: ['localhost'] }); // excluding sending errors from unit tests
@Injectable()
export class RaygunErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(e: any) {
    const appConfig = this.injector.get(AppConfig);
    rg4js('enableCrashReporting', appConfig.isRaygunEnabled);

    if (appConfig.isRaygunEnabled) {
      rg4js('send', {
        error: e,
      });
    }
    throw e;
  }
}
